"use strict";
/*
 * Created on 15. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var RoundedProductPrice_1 = require("../../product/model/RoundedProductPrice");

var UserMessageCode_1 = require("../../user-messages/model/UserMessageCode");
/**
 * Optimal price with or without constraints. Price value doesn't have to be set, then it serves as wrapper
 * for rangeMin and rangeMax. You should use `OptimalPrice.isSet(price)` to check, whether object contain the price.
 * This was done for LOG-6362.
 *
 * @author Radek Beran
 */


var OptimalPrice =
/*#__PURE__*/
function (_RoundedProductPrice_) {
  _inherits(OptimalPrice, _RoundedProductPrice_);

  /**
   * Creates new optimal price.
   * @param value optimal price value
   * @param valueRounded value of the price rounded according to rounding rules
   * @param rangeMin minimum of range used in optimal price calculation
   * @param rangeMax maximum of range used in optimal price calculation
   * @param repricingImportance importance of repricing; greater number means greater importance
   * @param forecastOld forecast of sold amount from optimization engine (for 30 days) with old settings
   * @param forecastNew forecast of sold amount from optimization engine (for 30 days) with new settings
   * @param validationResult validation messages
   */
  function OptimalPrice(value, valueRounded, rangeMin, rangeMax, repricingImportance, forecastOld, forecastNew, validationResult) {
    var _this;

    _classCallCheck(this, OptimalPrice);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptimalPrice).call(this, value, valueRounded));
    _this.value = value;
    _this.valueRounded = valueRounded;
    _this.rangeMin = rangeMin;
    _this.rangeMax = rangeMax;
    _this.repricingImportance = repricingImportance;
    _this.forecastOld = forecastOld;
    _this.forecastNew = forecastNew;
    _this.validationResult = validationResult;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to optimal price.
   */


  _createClass(OptimalPrice, [{
    key: "getNewOrOldForecast",
    value: function getNewOrOldForecast() {
      return this.forecastNew !== null ? this.forecastNew : this.forecastOld;
    }
  }, {
    key: "withValidationResult",
    value: function withValidationResult(validationResult) {
      return this.copy('validationResult', validationResult);
    }
  }, {
    key: "withMessage",
    value: function withMessage(message) {
      return this.copy('validationResult', this.validationResult.addObject(message));
    }
    /**
     * Returns optimal price with given alerts added.
     * Given alerts are merged with the current ones.
     * @param validationResult
     */

  }, {
    key: "withPriceAlerts",
    value: function withPriceAlerts(validationResult) {
      // Remove old price alerts
      // TODO RBe: Do not duplicate this in FinalProductPrice
      var messagesToClean = immutable_1.Set.of(UserMessageCode_1.UserMessageCode.PriceViolatesRefPriceDistance, UserMessageCode_1.UserMessageCode.PriceViolatesPriceChangeLimit, UserMessageCode_1.UserMessageCode.PriceViolatesPromoPriceDistance, UserMessageCode_1.UserMessageCode.MarginOutOfRange, UserMessageCode_1.UserMessageCode.PriceBreaksFamilySizePricing, UserMessageCode_1.UserMessageCode.PriceBreaksFamilyLinePricing);
      var currentCleaned = this.validationResult.removeObjectsWithMessageKeys(messagesToClean); // Add new alerts

      return this.copy('validationResult', currentCleaned.mergeWithResult(validationResult));
    }
  }, {
    key: "withPriceValue",
    value: function withPriceValue(value, valueRounded) {
      return this.copy('value', value).copy('valueRounded', valueRounded);
    }
    /**
     * Check whether given variable contains OptimalPrice with value.
     * @param price
     */

  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new OptimalPrice(mat.value, mat.valueRounded, mat.rangeMin, mat.rangeMax, mat.repricingImportance, mat.forecastOld, mat.forecastNew, mat.validationResult);
    }
  }, {
    key: "isSet",
    value: function isSet(price) {
      return price != null && price.value != null;
    }
  }]);

  return OptimalPrice;
}(RoundedProductPrice_1.RoundedProductPrice);

exports.OptimalPrice = OptimalPrice;

OptimalPrice.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(OptimalPrice.name);
  return {
    value: builder.opt(builder.bigNum('value')),
    valueRounded: builder.opt(builder.bigNum('valueRounded')),
    rangeMin: builder.bigNum('rangeMin'),
    rangeMax: builder.bigNum('rangeMax'),
    repricingImportance: builder.opt(builder.bigNum('repricingImportance')),
    forecastOld: builder.opt(builder.bigNum('forecastOld')),
    forecastNew: builder.opt(builder.bigNum('forecastNew')),
    validationResult: builder.obj('validationResult', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    })
  };
}();